import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import { getOSM, getGUI } from '../OverworldAnimation.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';
import Pokemon from '../entities/Pokemon.js';

export default class KeyboardMenuUI extends Drawable {
    constructor({ position = { x: 0, y: 0 } }) {
        super({ position });
        this.visible = false;
        this.background = new Sprite({
            position: position,
            image: imageStore.get('img/keyboard_menu_bg.png'),
            moving: false,
            visible: true,
        });
        this.lettersSprite = new Sprite({
            position: {
                x: 35,
                y: 80,
            },
            image: imageStore.get('img/keyboard_keys.png'),
            frames: { val: 0, max: 2 },
            moving: false,
            visible: true,
        });
        this.currentCharIndicator = new Sprite({
            position: {
                x: 35,
                y: 80,
            },
            image: imageStore.get('img/current_char_indicator.png'),
            moving: true,
            frames: { val: 0, max: 8 },
            hold: 8,
        });
        this.targetSprite = {
            player: new Sprite({
                position: {
                    x: 48,
                    y: 36,
                },
                image: getOSM().player.overworldImages[getOSM().player.gender].down.walk,
                frames: { max: 4 },
                moving: true,
                hold: 8,
            }),
            pokemon: {},
        };
        this.targetDisplayText = new PixelText({
            text: '',
            position: {
                x: 72,
                y: 37,
            },
            color: 'black',
            textAlign: 'left',
            visible: true,
        });
        this.outputText = new PixelText({
            text: '',
            position: {
                x: 100,
                y: 53,
            },
            color: 'black',
            textAlign: 'left',
            visible: true,
        });
    }

    setTargetSprite(targetSprite) {
        this.targetSprite[getOSM().keyboardMenu.targetType] = targetSprite;
        this.targetSprite[getOSM().keyboardMenu.targetType].position = {
            x: 48,
            y: 32,
        };
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.background.draw();
        this.targetDisplayText.text = getOSM().keyboardMenu.targetDisplayText;
        this.targetDisplayText.draw();
        this.outputText.text = getOSM().keyboardMenu.output;
        this.outputText.draw();
        if (this.targetSprite === null) {
            // console.warn('Keyboard UI target is not set.');
        } else {
            if (getOSM().keyboardMenu.targetType === 'player') {
                this.targetSprite[getOSM().keyboardMenu.targetType].setImage(
                    getOSM().player.overworldImages[getOSM().player.gender].down.walk
                );
                this.targetSprite.player.draw();
            } else if (getOSM().keyboardMenu.targetType === 'pokemon') {
                const targetPokemonId = getGUI().pokemonMenu.getCurrentPokemon().id;
                const pokemonIconSprite = Pokemon.createIconSpriteForId(targetPokemonId);
                this.setTargetSprite(pokemonIconSprite);
                this.targetSprite.pokemon.draw();
            }
        }
        this.lettersSprite.frames.val = getOSM().keyboardMenu.uppercase ? 0 : 1;
        this.lettersSprite.draw();
        this.currentCharIndicator.position = {
            x: 35 + 12 * getOSM().keyboardMenu.currentOption.x,
            y: 80 + 16 * getOSM().keyboardMenu.currentOption.y,
        };
        this.currentCharIndicator.draw();
    }
}
